// extracted by mini-css-extract-plugin
module.exports = {"support":"ErrorSupport_support__32D8A","logout":"ErrorSupport_logout__1jj-6","call":"ErrorSupport_call__3YiT-"};